"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../util/basicTypes/index");
var index_2 = require("../util/operator/index");
var AbstractSyntaxTree = /** @class */ (function () {
    function AbstractSyntaxTree(operator) {
        this.left = null; //左操作数
        this.right = null; //右操作数
        this.parent = null; //下一优先级运算步骤
        this.type = "exp";
        this.operator = new index_2.Operator(operator);
        this.hasCalculation = false;
        this.startIndex = 0;
        this.endIndex = 0;
    }
    AbstractSyntaxTree.prototype.setLeft = function (abstractSyntaxTree) {
        this.left = abstractSyntaxTree;
    };
    AbstractSyntaxTree.prototype.setRight = function (abstractSyntaxTree) {
        this.right = abstractSyntaxTree;
    };
    AbstractSyntaxTree.prototype.setParent = function (abstractSyntaxTree) {
        this.parent = abstractSyntaxTree;
    };
    AbstractSyntaxTree.prototype.setOperator = function (operator) {
        if (typeof operator === "string") {
            this.operator = new index_2.Operator(operator);
        }
        else {
            this.operator = operator;
        }
    };
    AbstractSyntaxTree.prototype.toAtom = function () {
        var type, value;
        return new index_1.Atom(this.type, "unknow", this.value);
    };
    AbstractSyntaxTree.prototype.calculation = function (ctx) {
        //计算
        var result = new index_1.Atom("undefined", "result");
        if (this.operator.sign === "") {
            return this.type === "variable" ? index_1.getVariable(this.value, ctx) : this.toAtom();
        }
        for (var i = 0; i < index_2.operation.length; i++) {
            if (index_2.operation[i].name === this.operator.sign) {
                result = index_2.operation[i].fn(this.left, this.right, ctx);
                break;
            }
        }
        this.result = result;
        return this.result;
    };
    return AbstractSyntaxTree;
}());
exports.AbstractSyntaxTree = AbstractSyntaxTree;
